import React, { useRef } from 'react'
import { Button, Grid,InputAdornment,TextField, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import * as yup from 'yup'
import colors from '../components/colors';
import { useFormik } from 'formik';
import { ReactComponent as IconEasyPayLogo } from '../icons/epIcon.svg';
import { ReactComponent as IconClose } from '../icons/closeButton.svg';
import { selectGlobalDataState } from '../features/global/globalDataSlice';
import { sendGeneralRequest } from '../features/generalRequest';
import  { selectForgotPasswordState, setIsPasswordSuccessfullyChanged } from '../features/resetPassword/forgotPasswordSlice';
import { useNavigate, useLocation }  from "react-router-dom";
import { setGeneralMessage, setToken } from '../features/global/globalDataSlice';
import Lottie from "lottie-react";
import smallLoadingAnimation from '../icons/lottieAnimations/smallLoading.json'
import RegistrationPasswordTextValidator from '../components/general/RegistrationPasswordTextValidator'
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { texts } from '../components/general/texts';
import { Toast } from 'primereact/toast';
        

const validationSchema = yup.object({
    password: yup
      .string()
      .required(texts["message-invalid-change-password"])
      .matches(
        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/,
        ' '
      ),
    newpassword: yup
    .string()
    .required(texts["message-invalid-change-password"])
    .matches(
        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/,
        ' '
      ),
})

const ForgotPassword = () => 
{
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const globalDataSliceState = useSelector(selectGlobalDataState)
    const forgotPasswordSliceState = useSelector(selectForgotPasswordState)
    const toast = useRef(null);

    const formik = useFormik({
        initialValues: {
            token: globalDataSliceState.token,
            password:'',
            newpassword:''
        },
        validationSchema: validationSchema,
        onSubmit: values => {
            dispatch(sendGeneralRequest({request: values, baseUrlKey:'auth', endpoint:'ChangePassword'})).then(response => {
                if(response.payload.response.success){
                    show()
                    formik.resetForm()
                }
            })
        }
    })

    const [showPassword, setShowPassword] = React.useState(false);
    const [showNewPassword, setShowNewPassword] = React.useState(false);

    const show = () => {
        toast.current.show({ severity: 'success', detail: 'Fjalëkalimi u ndryshua me sukses!' });
    };

        
    React.useEffect(()=>{
        if(forgotPasswordSliceState.isPasswordSuccessfullyChanged)
        {
            dispatch(setGeneralMessage({type: forgotPasswordSliceState.success === true ? 'success' : 'error', message: forgotPasswordSliceState.message}))
            dispatch(setToken(forgotPasswordSliceState.token))
            dispatch(setIsPasswordSuccessfullyChanged(false))
        }     
    }, [forgotPasswordSliceState.isPasswordSuccessfullyChanged])
    
    return(
        <form>
            <Grid container justifyContent='center' width={'100%'} pt={2} rowSpacing={10}>
                <Grid item md={6}  display={{xs :'none', md:'block'}} >
                    <IconEasyPayLogo width={'20%'} />
                </Grid>
                <Grid container item md={6} xs={10} marginBottom={9} mt={4} justifyContent={'center'} sx={{'@media (max-width: 899px)' : {justifyContent:'right'}}} >
                    <Button sx={{borderRadius:'20px', ":hover":{backgroundColor:colors.lightOrange}}} onClick={()=> { navigate('/dashboard') }}><IconClose/></Button>  
                </Grid>
                <Grid item md={12} xs={12} marginBottom={8.5}>
                    <Typography sx={{fontFamily:'GerberaBold', color:colors.darkBlue, fontSize:'2rem'}} >{texts["title-change-password"]}</Typography>
                </Grid>
                <Grid container item sx={{width:'60%', pl:'9.5%','@media (max-width: 899px)' : {width:'80%'} }}>
                    <Grid container item md={6} xs={12} flexDirection='column'>
                        <Grid container item justifyContent='flex-start' mb={2}>
                            <Typography sx={{color: colors.orange, fontSize:'1.2rem', fontFamily:'GerberaMedium'}} >{texts["placeholder-old-password"]}</Typography>
                        </Grid>
                        <Grid container item justifyContent='flex-start' mb={2}>
                            <TextField id="password" name="password" autoComplete="off" onChange={formik.handleChange} value={formik.values.password} error={formik.touched.password && Boolean(formik.errors.password)} helperText={formik.touched.password && formik.errors.password} color="warning" type={showPassword ? "text" : "password"} variant="outlined" InputProps={{endAdornment:<InputAdornment position="end"><Button disableRipple={true} onClick={() => setShowPassword(s => !s)} sx={{background:colors.white, color:colors.darkBlue, borderRadius:'100%', height:'5px', ':hover':{background:colors.white}}} >{showPassword === false && <VisibilityIcon />}{showPassword === true &&<VisibilityOffIcon />}</Button></InputAdornment>}} sx={{width:'15vw','@media (max-width: 899px)':{width:'50vw'}}} />
                        </Grid>      
                    </Grid>
                    <Grid container item md={6} xs={12} flexDirection='column'>
                        <Grid container item justifyContent='flex-start' mb={2}>
                            <Typography sx={{color: colors.orange, fontSize:'1.2rem', fontFamily:'GerberaMedium'}} >{texts["placeholder-new-password"]}</Typography>
                        </Grid>
                        <Grid container item justifyContent='flex-start' mb={2}>
                            <TextField id="newpassword" name="newpassword" autoComplete="off" onChange={formik.handleChange} value={formik.values.newpassword} error={formik.touched.newpassword && Boolean(formik.errors.newpassword)} helperText={formik.touched.newpassword && formik.errors.newpassword} color="warning" type={showNewPassword ? "text" : "password"}  variant="outlined" InputProps={{endAdornment:<InputAdornment position="end"><Button disableRipple={true} onClick={() => setShowNewPassword(s => !s)} sx={{background:colors.white,height:'5px', color:colors.darkBlue, borderRadius:'100%', ':hover':{background:colors.white}}} >{showNewPassword === false && <VisibilityIcon />}{showNewPassword === true &&<VisibilityOffIcon />}</Button></InputAdornment>}} sx={{width:'15vw','@media (max-width: 899px)':{width:'50vw'}}} />
                        </Grid>
                        <Grid container item justifyContent='flex-start' mb={7}>
                            <RegistrationPasswordTextValidator password={formik.values.newpassword}/>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item md={12} xs={12}>
                    <Button disabled={forgotPasswordSliceState.isLoading ? true : false} onClick={formik.handleSubmit}  sx={{background:colors.gradientOrange, color:colors.white, width:'12%', fontSize:'1rem' , fontFamily:'GerberaBold', textTransform:'none','@media (max-width: 899px)' : {width:'30%', mb:10, mt:'-25%'} }}>{texts["button-continue"]}</Button>
                </Grid>
                <Grid container justifyContent={'center'} >
                    <Grid container item md={1} xs={1} >
                        {forgotPasswordSliceState.isLoading && <Lottie animationData={smallLoadingAnimation} loop={true} autoplay={true}/>}    
                    </Grid>
                </Grid>        
            </Grid>
            <Toast ref={toast} />
        </form>
    )
}
export default ForgotPassword